import { calendarDateSchema } from '../validators/calendar-date.validator.js'

/**
 * When a change answered "Changed" really happened, `YYYY-MM-DD`, said by
 * the person making it with no visit open: at a desk, months after the
 * client took a tree down (docs/site-visits.md). A change made in a visit is
 * dated by the visit and this is ignored. Left out, the change is dated the
 * day it is made; a day still to come is taken as today rather than refused,
 * since a refused change fails a phone's whole queue.
 */
export const changedOnSchema = calendarDateSchema.optional()
